<script>
import axios from "axios";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
let user = JSON.parse(localStorage.getItem("user"));
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
/**
 * Register component
 */
export default {
  page: {
    title: "Quản lý lương",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },

  data() {
    return {
      json_fields: {
        User: "user.username",
        "Ngày tháng": "date",
        "Mã đơn ": "invoice",
        "Loại dịch vụ": "service_name",
        "Tiền thu được": "total_changer",
        "Tiền nhận": "salary",
        "Tiền Nhận Từ hải quan": "tax_keep",
        "Thu nhập": "profit",
        "Thông tin thô đơn hàng": {
          field: "bid",
          callback: (value) => {
            return `${JSON.stringify(value)}`;
          },
        },
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      columns: [
        {
          label: "Người dùng",
          field: "user.username",
        },
        {
          label: "Ngày tạo",
          field: "date",
        },
        {
          label: "Mã đơn ",
          field: "invoice",
        },
        {
          label: "Loại dịch vụ",
          field: "service_name",
        },
        {
          label: "Doanh thu",
          field: "total_changer",
        },

        {
          label: "Tiền nhận",
          field: "salary",
        },

        {
          label: "Tiền nhận từ thuế",
          field: "tax_keep",
        },

        {
          label: "Thu nhập",
          field: "_id",
        },
        {
          label: "Tình trạng",
          field: "status",
        },
      ],
      rows: [],
      value: null,
      finance: null,
      total: 0,
      finance: {
        total_order: 0,
        total_changer: 0,
        total_salary: 0,
        total_profit:0,
        total_order: 0,
        fixed_cost: 0,
        no_fixed_cost: 0,
        total: 0,
        total_label: 0,
        total_lb: 0,
      },
    };
  },
  methods: {
    formatDate(_data) {
      return moment(_data).format("DD-MM-YYYY mm:hh ");
    },

    changerRefetch(date, type) {
      axios({
        url: process.env.VUE_APP_SERVER_URL + `/api/finance`,
        method: "post",
        headers: {
          authorization: user.token,
        },
        data: {
          date: this.value,
        },
      }).then(({ data }) => {
        this.rows = data ? data : [];
        let total_changer = 0;
        let total_salary = 0;
        let total_profit = 0;
        let total_tax = 0;
        let total_order = 0;
        let total_lb = 0;
        let total_label = 0;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          total_order = data.length;
          total_changer = parseFloat(
            (Number(total_changer) + Number(item.total_changer)).toFixed(2)
          );
         
         
         total_profit = parseFloat(
            (
              Number(total_profit) +
              Number(item.salary) +
              Number(item.tax_keep)
            ).toFixed(2)
          );

          if (total_salary) {
            total_salary = parseFloat(
              (Number(total_salary) + Number(item.salary)).toFixed(2)
            );
          }
          if (Number(item.tax_keep) > 0) {
            total_tax = parseFloat(
              (Number(total_tax) + Number(item.tax_keep)).toFixed(2)
            );
          }

          if (Number(item.label) > 0) {
            total_label = parseFloat(
              (Number(total_label) + Number(item.label)).toFixed(2)
            );
          }

          total_lb = parseFloat(
            (Number(total_lb) + Number(item.total_weight)).toFixed(2)
          );
        }

        this.finance = {
          total_order: total_order,
          total_changer: total_changer,
          total_order: total_order,
          total_profit: total_profit,
          total_salary:total_salary,
          total_tax: total_tax,
          fixed_cost: 0,
          no_fixed_cost: 0,
          total: (total_changer - total_profit).toFixed(2),
          total_lb: total_lb,
          total_label: total_label,
        };
      });
    },
    renderName() {
      return moment().format("hh:mm DD-MM-YYYY") + "-danh-sach-don.xls";
    },

    changerFinance() {
      let total =
        Number(this.finance.total_changer) - Number(this.finance.total_salary);
      if (this.finance.fixed_cost > 0) {
        total -= this.finance.fixed_cost;
      }
      if (this.finance.no_fixed_cost > 0) {
        total -= Number(this.finance.no_fixed_cost);
      }
      this.finance.total = parseFloat(total.toFixed(2));
    },
  },

  async created() {
    if (user) {
      axios({
        url: process.env.VUE_APP_SERVER_URL + `/api/finance`,
        method: "post",
        headers: {
          authorization: user.token,
        }
      }).then(({ data }) => {
        this.rows = data ? data : [];
        let total_changer = 0;
        let total_salary = 0;
        let total_profit = 0;
        let total_tax = 0;
        let total_order = 0;
        let total_lb = 0;
        let total_label = 0;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          total_order = data.length;
          total_changer = parseFloat(
            (Number(total_changer) + Number(item.total_changer)).toFixed(2)
          );
         
         
         total_profit = parseFloat(
            (
              Number(total_profit) +
              Number(item.salary) +
              Number(item.tax_keep)
            ).toFixed(2)
          );

          if (total_salary) {
            total_salary = parseFloat(
              (Number(total_salary) + Number(item.salary)).toFixed(2)
            );
          }
          if (Number(item.tax_keep) > 0) {
            total_tax = parseFloat(
              (Number(total_tax) + Number(item.tax_keep)).toFixed(2)
            );
          }

          if (Number(item.label) > 0) {
            total_label = parseFloat(
              (Number(total_label) + Number(item.label)).toFixed(2)
            );
          }

          total_lb = parseFloat(
            (Number(total_lb) + Number(item.total_weight)).toFixed(2)
          );
        }

        this.finance = {
          total_order: total_order,
          total_changer: total_changer,
          total_order: total_order,
          total_profit: total_profit,
          total_salary:total_salary,
          total_tax: total_tax,
          fixed_cost: 0,
          no_fixed_cost: 0,
          total: (total_changer - total_profit).toFixed(2),
          total_lb: total_lb,
          total_label: total_label,
        };
      });
   
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader />

    <div>
      <div>
        <h3 class="h5">Báo cáo doanh thu</h3>
        <hr />
      </div>

      <div class="my-2">
        <el-date-picker
          v-model="value"
          type="datetimerange"
          align="right"
          @change="changerRefetch"
          start-placeholder="Ngày tháng bắt đầu"
          end-placeholder="Ngày tháng kết thúc"
        >
        </el-date-picker>
      </div>

      <div class="table-responsive">
        <div class="card">
          <div class="card-body">
            <table
              class="table table-bordered border-primary"
              style="border-color: #000 !important"
            >
              <thead>
                <tr>
                  <th>Tổng số hóa đơn</th>
                  <th>Tổng cân nặng</th>
                  <th>Tổng thùng hàng</th>
                  <th>Tổng doanh thu</th>
                  <th>Chi phí nhân viên</th>
                  <th width="80px">Chi phí cố định</th>
                  <th width="80px">Chi phí không cố định</th>
                  <th>Lợi nhuận</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ finance.total_order }}</td>
                  <td>{{ finance.total_lb }}</td>
                  <td>{{ finance.total_label }}</td>
                  <td>{{ finance.total_changer }}</td>
                  <td>{{ finance.total_profit }}</td>
                  <td>
                    <input
                      type="number"
                      class="form-control input-form-control"
                      @change="changerFinance"
                      v-model="finance.fixed_cost"
                      placeholder="Nhập số"
                      style="width: 120px"
                    />
                  </td>
                  <td>
                    <input
                      style="width: 150px"
                      type="number"
                      class="form-control input-form-control"
                      @change="changerFinance"
                      v-model="finance.no_fixed_cost"
                      placeholder="Nhập số"
                    />
                  </td>
                  <td>{{ finance.total }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="text-sm-end">
          <export-excel
            class="btn mb-2 btn-info btn-sm btn-default"
            :data="rows"
            :fields="json_fields"
            worksheet="list bill"
            :name="renderName()"
          >
            Download
          </export-excel>
          <vue-good-table
            :pagination-options="{
              enabled: true,
              rowsPerPageLabel: 'các mục trong trang',
              nextLabel: 'tiếp',
              prevLabel: 'trước',
              mode: 'records',
              allLabel: 'Tất cả',
            }"
            :line-numbers="true"
            :columns="columns"
            :rows="rows"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'up'">
                {{ formatDate(props.formattedRow[props.column.field]) }}
              </span>

              <span v-else-if="props.column.field == '_id'">
                {{ (props.row.tax_keep + props.row.salary).toFixed(2) }}
              </span>

              <span v-else-if="props.column.field == 'status'">
                <button
                  v-if="props.formattedRow[props.column.field] == 'false'"
                  class="btn btn-sm btn-danger"
                  type="button"
                >
                  Đơn bị hủy
                </button>

                <button
                  v-if="props.formattedRow[props.column.field] == 'null'"
                  type="button"
                  class="btn btn-sm btn-info"
                >
                  Đang vận chuyển
                </button>

                <button
                  v-if="props.formattedRow[props.column.field] == 'true'"
                  type="button"
                  class="btn btn-sm btn-success"
                >
                  Đã hoàn thành
                </button>
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>